import { useState } from "react";
import type { IPatientType } from "@medoma/models/patients";
import { TemplateInvoicingCodesPicker } from "./TemplateInvoicingPicker";
import type { TemplateInvoicingCodesPickerFields } from "@/pages/template-manager/TemplateForm/templateFormSchema";
import { useFieldPathWithPrefix } from "@/forms/FormFieldPathPrefixContext";
import { InvoicingCodesDisclosure } from "@/forms/InvoicingCodesDisclosure/InvoicingCodesDisclosure";
import { useInvoicingCodes } from "@/api/Invoicing";

export const TemplateAddInvoicingCodesAction = ({
  selectedPatientType,
}: {
  selectedPatientType: IPatientType;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const procedureCodesFieldName =
    useFieldPathWithPrefix<TemplateInvoicingCodesPickerFields>(
      "procedureCodes",
    );
  const productCodesFieldName =
    useFieldPathWithPrefix<TemplateInvoicingCodesPickerFields>("productCodes");
  const { data: invoicingCodes } = useInvoicingCodes({
    patientType: selectedPatientType,
    codeType: null,
  });

  if (!invoicingCodes || invoicingCodes.length === 0) {
    return null;
  }

  return (
    <InvoicingCodesDisclosure
      procedureCodesFieldName={procedureCodesFieldName}
      productCodesFieldName={productCodesFieldName}
      invoicingCodes={invoicingCodes}
      isExpanded={isExpanded}
      onExpandedChange={setIsExpanded}
    >
      <TemplateInvoicingCodesPicker selectedPatientType={selectedPatientType} />
    </InvoicingCodesDisclosure>
  );
};
